export default "<div #expandWrapper class='expand-wrapper' [class.collapsed]=\"!expanded\">\n    <ng-content></ng-content>\n  </div>\n  "